import { CanActivateFn } from '@angular/router';
import { UserRole } from '@app/core/models/user-role';
import { inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';

export function roleCheckGuard(...allowedRoles: UserRole[]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    return auth.hasAnyRole(allowedRoles);
  };
}
